var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlcohol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01061 22C6.01061 21.4477 6.45833 21 7.01061 21H17.0106C17.5629 21 18.0106 21.4477 18.0106 22C18.0106 22.5523 17.5629 23 17.0106 23H7.01061C6.45833 23 6.01061 22.5523 6.01061 22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0106 13C12.5629 13 13.0106 13.4477 13.0106 14V22C13.0106 22.5523 12.5629 23 12.0106 23C11.4583 23 11.0106 22.5523 11.0106 22V14C11.0106 13.4477 11.4583 13 12.0106 13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20188 1.41182C7.39006 1.15308 7.69068 1 8.01061 1H16.0106C16.3305 1 16.6312 1.15308 16.8193 1.41181C18.5806 3.83348 19.8109 7.62228 18.4263 10.7765C17.3504 13.2276 14.8912 15 12.0106 15C9.24313 15 6.85273 13.3939 5.71699 11.0675C4.14881 7.85488 5.38417 3.91115 7.20188 1.41182ZM7.51424 10.1901C6.47327 8.05744 7.12782 5.16574 8.53608 3L7.51424 10.1901ZM8.53608 3H15.4852C16.8465 5.09288 17.5154 7.87593 16.595 9.97259C15.8183 11.742 14.0494 13 12.0106 13C10.0364 13 8.32751 11.8559 7.51424 10.1901"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcohol);
export default __webpack_public_path__ + "static/media/alcohol.670668ecc64dbfb525e9eb98e47c0f8e.svg";
export { ForwardRef as ReactComponent };